import React, { useState, useEffect } from 'react';
import Axios from "axios";

import { MDBListGroup, MDBListGroupItem, MDBCheckbox, MDBBtn } from 'mdb-react-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import { CSVLink } from "react-csv";
import { backendPathCustomers } from '../Constants';
import ExcelExport from "./ExcelExport";
import Moment from "moment/moment";


function ExportCustomers() {
    const [customerList, setCustomerList] = useState([]);
    const [customersGenerated, setCustomersGenerated] = useState(false);
    const [csvData, setCSVData] = useState([]);

    const [firstName, setFirstName] = useState(0);
    const [lastName, setLastName] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [address, setAddress] = useState(0);
    const [birthday, setBirthday] = useState(0);
    const [insurance, setInsurance] = useState(0);
    const [degreeOfCare, setDegreeOfCare] = useState(0);
    const [secondPerson, setSecondPerson] = useState(0);
    const [thirdPerson, setThirdPerson] = useState(0);
    const [escalation, setEscalation] = useState(0);
    const [annotation, setAnnotation] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [partner, setPartner] = useState(0);
    const [officeEmployee, setOfficeEmployee] = useState(0);


    const getCustomers = (c) => {
        Axios.get(backendPathCustomers+"customers-complete.php").then((response) => {
            setCustomerList(response.data);
            console.log(response.data);
        });
    }

    const customerOptionsSelected = () => {
        return firstName || lastName || phoneNumber || address || birthday || insurance || degreeOfCare || secondPerson || thirdPerson || escalation || annotation || inactive || partner || officeEmployee;
    };

    const generateCustomers = () => {
        getCustomers();
    };

    const handleChange = () => {
        setCustomersGenerated(false);
        setCSVData([]);
    };

    useEffect(() => {
        if (customerList.length && !customersGenerated) {
            const data = [];
            const columns = [];

            if (firstName) {
                columns.push("Vorname");
            }
            if (lastName) {
                columns.push("Nachname");
            }
            if (phoneNumber) {
                columns.push("Telefonnummer");
            }
            if (address) {
                columns.push("Strasse");
                columns.push("Hausnummer");
                columns.push("PLZ");
                columns.push("Stadt");
            }
            if (birthday) {
                columns.push("Geburtstag");
            }
            if (insurance) {
                columns.push("Pflegekasse");
            }
            if (degreeOfCare) {
                columns.push("Pflegegrad");
            }
            if (secondPerson) {
                columns.push("Vorname2");
                columns.push("Nachname2");
                columns.push("Telefonnummer2");
                columns.push("Strasse2");
                columns.push("Hausnummer2");
                columns.push("PLZ2");
                columns.push("Stadt2");
                columns.push("Geburtstag2");
                columns.push("Pflegekasse2");
                columns.push("Pflegegrad2");
            }
            if (thirdPerson) {
                columns.push("Vorname3");
                columns.push("Nachname3");
                columns.push("Telefonnummer3");
                columns.push("Beziehung3");
            }
            if (escalation) {
                columns.push("Eskalationen");
            }
            if (annotation) {
                columns.push("Anmerkungen");
            }
            if (inactive) {
                columns.push("Status");
            }
            if (partner) {
                columns.push("Partner");
            }
            if (officeEmployee) {
                columns.push("zuständiger Mitarbeiter");
            }

            data.push(columns);
            console.log(data);

            for (let i=0; i<customerList.length; i++) {
                var row = [];
                if (firstName) {
                    row.push(customerList[i].FirstName);
                }
                if (lastName) {
                    row.push(customerList[i].LastName);
                }
                if (phoneNumber) {
                    row.push(customerList[i].PhoneNumber);
                }
                if (address) {
                    row.push(customerList[i].Street);
                    row.push(customerList[i].HouseNumber);
                    row.push(customerList[i].ZIP);
                    row.push(customerList[i].City);
                }
                if (birthday) {
                    row.push(Moment(customerList[i].Birthday, "YYYY-MM-DD").format("DD.MM.YYYY"));
                }
                if (insurance) {
                    row.push(customerList[i].Insurance);
                }
                if (degreeOfCare) {
                    row.push(customerList[i].DegreeOfCare);
                }
                if (secondPerson) {
                    row.push(customerList[i].FirstName2);
                    row.push(customerList[i].LastName2);
                    row.push(customerList[i].PhoneNumber2 === "0" ? "" : customerList[i].PhoneNumber2);
                    row.push(customerList[i].Street2);
                    row.push(customerList[i].HouseNumber2);
                    row.push(customerList[i].HouseNumber2 === "0" ? "" : customerList[i].HouseNumber2);
                    row.push(customerList[i].ZIP2 === "0" ? "" : customerList[i].ZIP2);
                    row.push(customerList[i].City2);
                    row.push(customerList[i].Birthday2);
                    row.push(customerList[i].Insurance2);
                    row.push(customerList[i].DegreeOfCare2 === "0" ? "" : customerList[i].DegreeOfCare2);
                }
                if (thirdPerson) {
                    row.push(customerList[i].FirstName3);
                    row.push(customerList[i].LastName3);
                    row.push(customerList[i].PhoneNumber3 === "0" ? "" : customerList[i].PhoneNumber3);
                    row.push(customerList[i].Relation3);
                }
                if (escalation) {
                    row.push(customerList[i].Escalation);
                }
                if (annotation) {
                    row.push(customerList[i].Annotation);
                }
                if (inactive) {
                    if (Number(customerList[i].Inactive)) {
                        row.push("inaktiv");
                    }
                    else {
                        row.push("aktiv");
                    }
                }
                if (partner) {
                    row.push(customerList[i].PartnerName);
                }
                if (officeEmployee) {
                    if (customerList[i].OfficeEmployeeFirstName) {
                        row.push(customerList[i].OfficeEmployeeFirstName + " " + customerList[i].OfficeEmployeeLastName);
                    }
                    else {
                        row.push("");
                    }
                }

                data.push(row);
            }
            console.log(data);
            setCSVData(data);
            setCustomersGenerated(true);
        }
    }, [customerList]);


    return (
        <div>

            <div className='header2'>
                <h3>Kunden</h3>
                <MDBListGroup light>
                    <MDBListGroupItem>
                        <MDBCheckbox inline onChange={(e) => {
                            handleChange();
                            setFirstName(e.target.checked);
                            setLastName(e.target.checked);
                            setPhoneNumber(e.target.checked);
                            setAddress(e.target.checked);
                            setInsurance(e.target.checked);
                            setBirthday(e.target.checked);
                            setDegreeOfCare(e.target.checked);
                            setSecondPerson(e.target.checked);
                            setThirdPerson(e.target.checked);
                            setEscalation(e.target.checked);
                            setAnnotation(e.target.checked);
                            setInactive(e.target.checked);
                            setPartner(e.target.checked);
                            setOfficeEmployee(e.target.checked);
                        }} />
                        alles auswählen
                    </MDBListGroupItem>
                </MDBListGroup>
            </div>

            <MDBListGroup style={{ minWidth: '22rem' }} light>
                <MDBListGroupItem>
                    <MDBCheckbox inline checked={firstName} onChange={(event) => {handleChange(); setFirstName((firstName+1)%2);}} />
                    Vorname
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={lastName} onChange={(event) => {handleChange(); setLastName((lastName+1)%2);}} />
                    Nachname
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={phoneNumber} onChange={(event) => {handleChange(); setPhoneNumber((phoneNumber+1)%2);}} />
                    Telefonnummer
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={birthday} onChange={(event) => {handleChange(); setBirthday((birthday+1)%2);}} />
                    Geburtsdatum
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={address} onChange={(event) => {handleChange(); setAddress((address+1)%2);}} />
                    Adresse
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={insurance} onChange={(event) => {handleChange(); setInsurance((insurance+1)%2);}} />
                    Pflegekasse
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={degreeOfCare} onChange={(event) => {handleChange(); setDegreeOfCare((degreeOfCare+1)%2);}} />
                    Pflegegrad
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={secondPerson} onChange={(event) => {handleChange(); setSecondPerson((secondPerson+1)%2);}} />
                    Angaben zur 2. zu betreuenden Person
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={thirdPerson} onChange={(event) => {handleChange(); setThirdPerson((thirdPerson+1)%2);}} />
                    Angaben zur 2. Person im Haushalt
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={escalation} onChange={(event) => {handleChange(); setEscalation((escalation+1)%2);}} />
                    Eskalationen
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={annotation} onChange={(event) => {handleChange(); setAnnotation((annotation+1)%2);}} />
                    Anmerkungen
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={inactive} onChange={(event) => {handleChange(); setInactive((inactive+1)%2);}} />
                    Status
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={partner} onChange={(event) => {handleChange(); setPartner((partner+1)%2);}} />
                    Partner
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={officeEmployee} onChange={(event) => {handleChange(); setOfficeEmployee((officeEmployee+1)%2);}} />
                    zuständiger Mitarbeiter
                </MDBListGroupItem>
            </MDBListGroup>

            <div className="footer export">
                {!customerOptionsSelected() ?
                    <MDBBtn className="btn-disabled" disabled type="submit">
                        Tabelle generieren
                    </MDBBtn>
                : 
                (customersGenerated && csvData.length) ?
                    <>
                        <MDBBtn className="btn btn-csv" type="submit" onClick={() => document.getElementById("csv-link-customer").click()}>
                            <CSVLink id="csv-link-customer" filename='Kunden' data={csvData}>
                                <FontAwesomeIcon className='btn-icon' icon={faDownload} />
                                CSV herunterladen
                            </CSVLink>
                        </MDBBtn>

                        <ExcelExport data={csvData} fileName="Kunden" />
                    </>
                :
                    <MDBBtn className="btn" type="submit" onClick={generateCustomers}>
                        CSV generieren
                    </MDBBtn>
                }
            </div>
        </div>
    );
}

export default ExportCustomers;